import { ButtonElement } from "appworks/graphics/elements/button-element";
import { FlexiButton } from "appworks/graphics/elements/flexi-button";
import { Services } from "appworks/services/services";
import { ButtonControl } from "appworks/ui/controls/standard/button/button-control";
import { lastInArray } from "appworks/utils/collection-utils";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { slotModel } from "slotworks/model/slot-model";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";

export class AgsMaxBetButtonControl extends ButtonControl {
    protected onModelUpdateCallback: Function;

    constructor(button: FlexiButton) {
        super(button);

        this.onModelUpdateCallback = () => this.onModelUpdate();
        slotModel.onUpdate.add(this.onModelUpdateCallback);

        if (!gameiomModel.displayMaxBet) {
            this.enabled = false;
            this.setEnabled(false);
            this.button.getTargets().forEach((target) => {
                if (target instanceof ButtonElement) {
                    target.getLabels().forEach((label) => label.visible = false);
                }
            });
        }
    }

    public destroy(): void {
        super.destroy();
        this.button.setVisible(false);
        slotModel.onUpdate.remove(this.onModelUpdateCallback);
    }

    public setEnabled(enabled: boolean): void {
        const { freeBet } = slotModel.read().bet;
        super.setEnabled(enabled && !freeBet && gameiomModel.displayMaxBet);
    }

    protected onClick(): void {
        const { creditsPerLine } = slotModel.read().bet;

        const maxCreditsPerLine: number = lastInArray(creditsPerLine.values);
        creditsPerLine.currentValue = maxCreditsPerLine;

        slotModel.write({ bet: { creditsPerLine } });
    }

    protected onModelUpdate(): void {
        this.setEnabled(this.enabled);
    }
}
